import React, {FC} from 'react';

import {TeammateModel} from '../../../../../libs/shared/core/src/models/api/teammateModel';
import {
  buildTeammateDisplayName,
  isVisitorTeammate,
} from '../../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemSecondaryContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemSecondaryContent';
import {TeammateOnlineStatusesEnum} from '../../../../store/data/teammates/onlineTeammatesSelectors';
import {DropdownItemBadges} from '../dropdownItemBadges';
import {DropdownItemTeammateAvatarWithStatus} from '../dropdownItemTeammateAvatarWithStatus';

/*
 * Props.
 */

interface MentionDropdownItemProps extends DropdownItemProps {
  teammate: TeammateModel;
  isTeamMember: boolean;
  onlineStatus: TeammateOnlineStatusesEnum;
}

/*
 * Component.
 */

export const MentionDropdownItem: FC<MentionDropdownItemProps> = (props) => {
  const {isChecked, teammate, isTeamMember, onlineStatus} = props;
  const displayName = buildTeammateDisplayName(teammate);

  return (
    <DropdownItem {...props}>
      <DropdownItemTeammateAvatarWithStatus teammate={teammate} onlineStatus={onlineStatus} />
      <DropdownItemContent isChecked={isChecked} isBold>
        {isVisitorTeammate(teammate) ? '' : '@'}
        {teammate.alias}
      </DropdownItemContent>
      {displayName !== teammate.alias && (
        <DropdownItemSecondaryContent>{displayName}</DropdownItemSecondaryContent>
      )}
      <DropdownItemBadges
        isUnavailable={!teammate.isAvailable}
        isNonTeamMember={!isTeamMember}
        isUnverified={teammate.isUnverified}
      />
    </DropdownItem>
  );
};
